// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { applySlate } from "@sequentech/ui-core";
import { exceedsMaximum } from "./SelectionLimits";
var SlateChoicesError = /** @class */ (function (_super) {
    __extends(SlateChoicesError, _super);
    function SlateChoicesError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "SlateChoicesError";
        return _this;
    }
    return SlateChoicesError;
}(Error));
export { SlateChoicesError };
var describeProblems = function (error) {
    var problems = Array.isArray(error) ? error : [error];
    return problems
        .map(function (problem) { var _a; return (_a = problem === null || problem === void 0 ? void 0 : problem.message) !== null && _a !== void 0 ? _a : String(problem); })
        .join("; ");
};
/** The slate has more candidates in a contest than the contest allows. */
var SlateOverMaximumError = /** @class */ (function (_super) {
    __extends(SlateOverMaximumError, _super);
    function SlateOverMaximumError(slate, slateContest) {
        var _this = _super.call(this, "slate \"".concat(slate.id, "\" has ").concat(slateContest.candidates.length, " candidates in contest \"").concat(slateContest.contest.id, "\", which allows ").concat(slateContest.contest.max_votes)) || this;
        _this.slateContest = slateContest;
        _this.name = "SlateOverMaximumError";
        return _this;
    }
    return SlateOverMaximumError;
}(SlateChoicesError));
export { SlateOverMaximumError };
/**
 * The ballot that choosing a slate produces, and what it changes.
 *
 * The rule is sequent-core's: in each contest the slate covers, its candidates
 * replace the current marks, and contests it does not cover keep their choices.
 * The result is an ordinary selection, the same one marking those candidates
 * by hand gives. A slate that cannot be applied in full throws and applies
 * nothing.
 */
export var computeSlateChoices = function (slate, current) {
    var members = {};
    for (var _i = 0, _a = slate.contests; _i < _a.length; _i++) {
        var slateContest = _a[_i];
        var memberIds = new Set(slateContest.candidates.map(function (candidate) { return candidate.id; }));
        if (exceedsMaximum(slateContest.contest, memberIds.size)) {
            throw new SlateOverMaximumError(slate, slateContest);
        }
    }
    for (var _b = 0, _c = slate.contests; _b < _c.length; _b++) {
        var _d = _c[_b], contest = _d.contest, candidates = _d.candidates;
        members[contest.id] = candidates.map(function (candidate) { return candidate.id; });
    }
    try {
        var _e = applySlate({ id: slate.id, name: slate.name, members: members }, slate.contests.map(function (_a) {
            var contest = _a.contest;
            return contest;
        }), current), selection = _e.selection, changes = _e.changes;
        var covered_1 = new Set(Object.keys(members));
        return {
            // Choices exactly as the voting screen writes them when a candidate
            // is marked by hand.
            selection: selection.map(function (contest) {
                return covered_1.has(contest.contest_id)
                    ? __assign(__assign({}, contest), { choices: contest.choices.map(function (_a) {
                            var id = _a.id, selected = _a.selected;
                            return ({ id: id, selected: selected });
                        }) }) : contest;
            }),
            changes: changes.map(function (change) { return ({
                contestId: change.contest_id,
                added: change.added,
                removed: change.removed,
            }); }),
        };
    }
    catch (error) {
        throw new SlateChoicesError(describeProblems(error));
    }
};
export var slateRemovesChoices = function (choices) {
    return choices.changes.some(function (change) { return change.removed.length > 0; });
};
